module.exports = __webpack_public_path__ + "static/media/Investor-CHRIS DREES_MERCURY_SOLO_FINAL_1646358720770.044773fd.vtt";